import type {
  GroupChatMessage,
  TurnTrackerState,
  ConsensusConfirmState,
  PaginationState,
} from '../types/charterWsTypes'
import type { GroupStage, RatifiedCharter, RenegotiationRequest } from '../types/charterTypes'

export interface CharterGroupWsState {
  isConnected: boolean
  messages: GroupChatMessage[]
  currentStage: GroupStage | null
  turnTracker: TurnTrackerState
  consensusState: ConsensusConfirmState
  ratificationVotes: Record<string, { vote: boolean; voted_at: string }>
  ratificationVoteCount: number
  totalMembers: number
  isStreaming: boolean
  isModeratorThinking: boolean
  currentStreamId: string | null
  renegotiationMode: boolean
  ratifiedCharter: RatifiedCharter | null
  charterVersion: number
  charterStatus: string | null
  teamName: string | null
  pendingRenegotiationRequest: RenegotiationRequest | null
  ratificationPromptActive: boolean
  ratificationFinalizing: boolean
  error: string | null
  pagination: PaginationState | null
  isLoadingMore: boolean
}

const charterGroupWsInitialState: CharterGroupWsState = {
  isConnected: false,
  messages: [],
  currentStage: null,
  turnTracker: {},
  consensusState: {},
  ratificationVotes: {},
  ratificationVoteCount: 0,
  totalMembers: 0,
  isStreaming: false,
  isModeratorThinking: false,
  currentStreamId: null,
  renegotiationMode: false,
  ratifiedCharter: null,
  charterVersion: 1,
  charterStatus: null,
  teamName: null,
  pendingRenegotiationRequest: null,
  ratificationPromptActive: false,
  ratificationFinalizing: false,
  error: null,
  pagination: null,
  isLoadingMore: false,
}

export default charterGroupWsInitialState
